import { render, staticRenderFns } from "./ClinicDiscountUsageReport.vue?vue&type=template&id=451393d1&scoped=true"
import script from "./ClinicDiscountUsageReport.vue?vue&type=script&lang=js"
export * from "./ClinicDiscountUsageReport.vue?vue&type=script&lang=js"
import style0 from "./ClinicDiscountUsageReport.vue?vue&type=style&index=0&id=451393d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451393d1",
  null
  
)

export default component.exports